const securityFeatures = [
  'AES-256 bit encryption standard',
  'DNS leak protection enabled',
  'Automatic IP address masking',
  'Secure OpenVPN & IKEv2 protocols',
  'No third-party data sharing',
];

export default function Security() {
  return (
    <section id="security" className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 bg-slate-900"></div>
      
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, rgba(6, 182, 212, 0.3) 1px, transparent 0)',
          backgroundSize: '40px 40px'
        }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="order-2 md:order-1">
            <div className="text-xs font-bold tracking-widest text-cyan-400 mb-4">
              SECURITY FIRST
            </div>
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-8 leading-tight">
              Your Data
              <br />
              Stays Yours
            </h2>
            <div className="space-y-5 mb-10">
              {securityFeatures.map((feature, index) => (
                <div key={index} className="flex items-start gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-checkbox-circle-fill text-cyan-400 text-2xl"></i>
                  </div>
                  <span className="text-white text-lg">{feature}</span>
                </div>
              ))}
            </div>
            <a 
              href="#contact" 
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-slate-900 font-semibold rounded-full hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Learn Our Security Protocol
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>

          <div className="order-1 md:order-2 relative">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 to-purple-500/20 rounded-3xl blur-3xl"></div>
              <img 
                src="https://public.readdy.ai/ai/img_res/a205e2b8edb1cafa17d9dc811dcd8cec.jpg" 
                alt="Security Lock" 
                className="relative w-full h-auto rounded-3xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-transparent to-transparent rounded-3xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
